import comp from "./LeSearchModal";
export default comp;
